import Replies from './replies.vue'
export default Replies